import {IKeyDetail} from '../../../apis/user/getKey'
import WizImage from '../../../components/image/WizImage'
import Text from '../../../components/text/Text'
import useQueryExchanges from '../../../hooks/etc/useQueryExchanges'
import {useString} from '../../../utils/string'
import AssetContainer from './AssetContainer'
import PositionContainer from './PositionContainer'
import {useSearchParams} from 'react-router-dom'
import useQueryUserKeyDetail from '../../../hooks/api/user/useQueryGetKeyProfile'
import OpenOrderContainer from './OpenOrderContainer'
import {IKeyPortfolio} from '../../../apis/user/getKeyProfile'
import {copyToClipboard} from '../../../utils/etc'
import WizButton from '../../../components/button/WizButton'
import useNavigation from '../../../hooks/useNavigation'

interface IProps {
    className?: string
    data?: IKeyDetail
    hasDetail?: boolean
}

const KeyInfoContainer: React.FC<IProps> = ({className, data, hasDetail = true}) => {
    const {data: exchanges} = useQueryExchanges()
    const {shortCutString} = useString()
    const {data: keyDetail} = useQueryUserKeyDetail(data?.id)
    const {goKeyProbe} = useNavigation()

    return (
        <>
            <div className={`bg-white rounded-[10px] p-[30px] shadow-normal ${className}`}>
                <div className={'flex justify-between space-x-[20px]'}>
                    <div className={'flex items-center space-x-[10px]'}>
                        <div className={'relative flex-none'}>
                            <WizImage
                                src={exchanges?.find(exchange => exchange?.name === data?.exchange)?.icon}
                                className={'w-[36px]'}
                            />
                        </div>
                        <div className={'flex items-center space-x-[5px]'}>
                            <div className={'flex items-center space-x-[10px]'}>
                                <div className={'flex-none'}>
                                    <Text className={'text-ti1'}>{data?.name ? data.name : '[No API Name]'}</Text>
                                    <Text
                                        className={'text-body3 text-font03'}
                                        onClick={() => copyToClipboard(data?.id)}>
                                        ({shortCutString(data?.access_key)})
                                    </Text>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* 이 키가 왜 실패하는지 거래소 응답 원본으로 확인 — 실행은 Probe 페이지에서 명시적으로 한다. */}
                    {data?.id && (
                        <WizButton
                            type={'border'}
                            size={'small'}
                            text={'Probe'}
                            onClick={() => goKeyProbe(data.id)}
                            className={'flex-none self-start'}
                        />
                    )}
                </div>
                {hasDetail && (
                    <div className={'border-t border-line02 mt-[30px] pt-[30px] space-y-[30px]'}>
                        <div className="space-y-[5px]">
                            <AssetContainer data={data?.assets} />
                        </div>
                        <div className="space-y-[5px]">
                            <PositionContainer data={keyDetail?.latest_balance?.current_position} />
                        </div>
                        <div>
                            <OpenOrderContainer data={keyDetail?.open_orders} />
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}

export default KeyInfoContainer
